import * as React from 'react';
import { createSubcomponent, getTheme, styled, } from '@workday/canvas-kit-react/common';
import { Popup } from '@workday/canvas-kit-react/popup';
import { space } from '@workday/canvas-kit-react/tokens';
import { useModalHeading, useModalModel } from './hooks';
const ResponsiveModalHeading = styled(Popup.Heading)(({ theme }) => {
    const { canvas: canvasTheme } = getTheme(theme);
    return {
        [canvasTheme.breakpoints.down('s')]: {
            marginBottom: space.zero,
            padding: `${space.xxs} ${space.xxs} ${space.xxxs} ${space.xxs}`,
        },
    };
});
export const ModalHeading = createSubcomponent('h2')({
    displayName: 'Modal.Heading',
    modelHook: useModalModel,
    elemPropsHook: useModalHeading,
})((elemProps, Element) => {
    return React.createElement(ResponsiveModalHeading, Object.assign({ as: Element }, elemProps));
});
